<ng-container>
  <mat-form-field>
    <input matInput placeholder="Choose file" #fileNameInput readonly>
  </mat-form-field>

  <input #fileInput accept=".xls,.xlsx" type="file" [style.display]="'none'" (change)="setFilename($event)">
  <button mat-icon-button (click)="fileInput.click()" matSuffix>
    <mat-icon>folder</mat-icon>
  </button>

  <button mat-icon-button (click)="onUpload()" [disabled]="!fileNameInput.value || uploadDisabled">
    <mat-icon>file_upload</mat-icon>
  </button>
</ng-container>
